import { render, staticRenderFns } from "./Watermark.vue?vue&type=template&id=3219961c&scoped=true"
import script from "./Watermark.vue?vue&type=script&lang=js"
export * from "./Watermark.vue?vue&type=script&lang=js"
import style0 from "./Watermark.vue?vue&type=style&index=0&id=3219961c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3219961c",
  null
  
)

export default component.exports